import { Drawer as BaseDrawer } from "@base-ui/react/drawer";
import { IconX } from "@tabler/icons-react";
import clsx from "clsx";
import type { ComponentPropsWithoutRef } from "react";

import styles from "./Drawer.module.scss";

export const DrawerTrigger = BaseDrawer.Trigger;

export function Drawer(props: ComponentPropsWithoutRef<typeof BaseDrawer.Root>) {
  return <BaseDrawer.Root data-slot="drawer" {...props} />;
}

export function DrawerContent({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<typeof BaseDrawer.Popup>) {
  return (
    <BaseDrawer.Portal>
      <BaseDrawer.Backdrop data-slot="drawer-backdrop" className={styles.overlay} />
      <BaseDrawer.Popup
        data-slot="drawer-content"
        className={clsx(styles.content, className)}
        {...props}
      >
        {children}
      </BaseDrawer.Popup>
    </BaseDrawer.Portal>
  );
}

export function DrawerHeader({ className, ...props }: ComponentPropsWithoutRef<"div">) {
  return <div data-slot="drawer-header" className={clsx(styles.header, className)} {...props} />;
}

export function DrawerTitle({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof BaseDrawer.Title>) {
  return (
    <BaseDrawer.Title
      data-slot="drawer-title"
      className={clsx(styles.title, className)}
      {...props}
    />
  );
}

export function DrawerClose({
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<typeof BaseDrawer.Close>) {
  return (
    <BaseDrawer.Close
      data-slot="drawer-close"
      className={clsx(styles.closeButton, className)}
      aria-label="Close drawer"
      {...props}
    >
      {children ?? <IconX size={20} />}
    </BaseDrawer.Close>
  );
}

export function DrawerBody({
  className,
  noPadding,
  ...props
}: ComponentPropsWithoutRef<"div"> & { noPadding?: boolean }) {
  return (
    <div
      data-slot="drawer-body"
      className={clsx(styles.body, className)}
      {...(noPadding && { "data-no-padding": "true" })}
      {...props}
    />
  );
}
